import { component } from "picoapp";

export const videoControls = component((node: HTMLElement) => {
  const id = node.dataset.for;
  if (!id) {
    throw Error("videoControls component requires [data-for] attribute");
  }

  const video = document.querySelector<HTMLVideoElement>(`#${id}`);
  const pauseButton = node.querySelector<HTMLElement>("[data-pause]");
  const playButton = node.querySelector<HTMLElement>("[data-play]");

  if (!video || !pauseButton || !playButton) {
    throw Error(
      "videoControls component requires a video, pause button and play button"
    );
  }

  const showPlayButton = () => {
    pauseButton.style.display = "none";
    playButton.style.display = "block";
  };
  const showPauseButton = () => {
    playButton.style.display = "none";
    pauseButton.style.display = "block";
  };

  const pauseVideo = () => {
    video.pause();
    showPlayButton();
    playButton.focus();
  };

  const playVideo = () => {
    video.play();
    showPauseButton();
    pauseButton.focus();
  };

  video.addEventListener("ended", showPlayButton);
  pauseButton?.addEventListener("click", pauseVideo);
  playButton?.addEventListener("click", playVideo);

  return () => {
    video.removeEventListener("ended", showPlayButton);
    pauseButton.removeEventListener("click", pauseVideo);
    playButton.removeEventListener("click", playVideo);
  };
});
